import { PurchaseChannelRepository } from "@domain/purchase-channel/repositories/purchase-channel.repository";
import { PurchaseChannelRepositoryService } from "../repositories/purchase-channel.service";

export const PurchaseChannelProvider = [
  {
    provide: PurchaseChannelRepository,
    useClass: PurchaseChannelRepositoryService,
  },
];